const state = {
  rateVar: 0,
  fetusTurnRecordId: '',
  startAt: '',
  isLoading: false,
  hasLoginCache:false,
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  },
  DURING: (state, rateVar) => {
    state.rateVar = rateVar
  },
  COUNT: (state, params) => {
    state.fetusTurnRecordId = params.fetusTurnRecordId
    state.startAt = params.startAt
  },
  LOADING: (state, loading) => {
    state.isLoading = loading
  },
  CHANGE_LOGIN: (state, hasLoginCache) => {
    state.hasLoginCache = hasLoginCache
    localStorage.setItem('hasLoginCache', hasLoginCache ? 1 : 0)
  },
}

const actions = {
  during({ commit }, rateVar) {//数胎动计时
    commit('DURING', rateVar)
    console.log('rateVar', rateVar)
  },
  saveCount({ commit }, params) {
    commit('COUNT', params)
  },
  saveLoading({ commit }, loading) {
    commit('LOADING', loading)
  },
  changeLogin({ commit }, hasLoginCache) {
    commit('CHANGE_LOGIN', hasLoginCache)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/globalVar.js